import { createCustomSelector } from '../../domain/utils/react-reselect'
import { selectIsPE } from '../../store/navigation/navigation.selectors'
import { PAGE_CLASSES } from '../pageClasses.constants'

export default createCustomSelector(selectIsPE, pe => [pe && PAGE_CLASSES.withSubHeader])
